const TABS_SELECTOR = "[data-host-tabs]";

function revealActiveHostTab() {
  const tabs = document.querySelector(TABS_SELECTOR);
  const active = tabs?.querySelector('[aria-current="page"]');
  if (!tabs || !active || tabs.scrollWidth <= tabs.clientWidth) return;

  const tabsRect = tabs.getBoundingClientRect();
  const activeRect = active.getBoundingClientRect();
  if (activeRect.left >= tabsRect.left && activeRect.right <= tabsRect.right) return;

  tabs.scrollLeft += activeRect.left - tabsRect.left - (tabs.clientWidth - activeRect.width) / 2;
}

document.addEventListener("turbo:load", revealActiveHostTab);
